import { useTheme } from "@mui/material";
import { createSxStyles } from "../../common/createSxStyles";

export const useDetailsWrapperStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        scrollbar: {
            height: "100%",
        },
        container: {
            margin: theme.spacing(3),
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            fontSize: 20 + "px",
            fontWeight: theme.typography.fontWeightBold,
            borderBottom: "1px solid " + theme.palette.grey[300],
            marginBottom: theme.spacing(3),
        },
        title: {
            color: theme.palette.primary.dark,
        },
        date: {
            color: theme.palette.grey[400],
        },
        content: {
            color: theme.palette.primary.dark,
            fontSize: theme.typography.pxToRem(14),
            "& img": {
                width: "100%",
            },
        },
    });
};
